export default "__VITE_ASSET__CEr2DlYi__"